import { createApiSlice } from '@/shared/features/query/config/query.build';
import type { ReduxQueryClient } from '@/shared/features/query/domain/interfaces/QueryClient';
import type { FeatureFlags } from '../../domain/models/FeatureFlags';
import type { FeatureFlagsDto } from '../dto/FeatureFlagsDto';
import { mapFeatureFlagsDto } from '../mappers/featureFlags.mapper';

const featureFlagsApiSlice = createApiSlice({
  clientId: 'featureFlagsApi',
  tagTypes: ['FeatureFlags'],
  endpoints: {
    getFeatureFlags: {
      url: '/bs-util/properties',
      method: 'GET',
      transformResponse: (response: unknown): FeatureFlags => {
        const dto = (response ?? {}) as FeatureFlagsDto;
        if (dto.hasError) return { isSoftLoginEnabled: false };
        return mapFeatureFlagsDto(dto);
      },
      providesTags: ['FeatureFlags'],
    },
  },
});

export const featureFlagsApi = featureFlagsApiSlice.queryClient;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const hooks = featureFlagsApiSlice.hooks as any;
export const useGetFeatureFlagsQuery = hooks?.useGetFeatureFlagsQuery;

export const featureFlagsApiRedux = featureFlagsApiSlice.queryClient as ReduxQueryClient;

export default featureFlagsApiSlice;
